import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import store from './store';
import { ThemeProvider } from './context/ThemeContext';
import Layout from './components/Layout';
import DashboardPage from './pages/DashboardPage';
import PartnersPage from './pages/PartnersPage';
import RewardsPage from './pages/RewardsPage';
import ChallengesPage from './pages/ChallengesPage';
import ReportsPage from './pages/ReportsPage';
import LoginPage from './pages/LoginPage';
import PrivateRoute from './components/PrivateRoute';

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider>
      <Router>
        <ToastContainer position="bottom-right" autoClose={3000} />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/*"
            element={
              <PrivateRoute>
                <Layout>
                  <Routes>
                    <Route path="/dashboard" element={<DashboardPage />} />
                    <Route path="/partners" element={<PartnersPage />} />
                    <Route path="/rewards" element={<RewardsPage />} />
                    <Route path="/challenges" element={<ChallengesPage />} />
                    <Route path="/reports" element={<ReportsPage />} />
                    <Route path="/" element={<Navigate to="/dashboard" />} />
                  </Routes>
                </Layout>
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
